import React from "react";
import uuid from "react-uuid";
import git from "../images//version-control/Git.webp";
import react from "../images/Javascipt-ui/React.webp";
import redux from "../images/Javascipt-ui/redux.svg";
import vue from "../images/Javascipt-ui/vue.png";
import elementor from "../images/cms/elementor.png";
import wordpress from "../images/cms/wordpress.png";
import mongoDB from "../images/databases/MongoDB.webp";
import nodejs from "../images/frameworks/Nodejs.webp";
import expressjs from "../images/frameworks/expressjs.webp";
import tailwindcss from "../images/frontend-frameworks/TailwindCSS_1635323049726.webp";
import bootstrap from "../images/frontend-frameworks/bootstrap.png";
import reactBootstrap from "../images/frontend-frameworks/react-bootstrap.svg";
import photoshop from "../images/graphic/AdobePhotoshop.webp";
import figma from "../images/graphic/Figma.webp";
import css3 from "../images/languages/CSS3.webp";
import html from "../images/languages/HTML5.webp";
import javaScript from "../images/languages/JavaScript.webp";
import vscode from "../images/tools/VSCode_1635323116407.webp";
import firefox from "../images/web-browser/Firefox_1635868577257.webp";
import googleChrome from "../images/web-browser/GoogleChrome.webp";

const TechStack = () => {
  const languages = [
    {
      name: "javaScript",
      logo: javaScript,
      level: "expert",
    },
    {
      name: "html",
      logo: html,
      level: "expert",
    },
    {
      name: "css3",
      logo: css3,
      level: "expert",
    },
  ];
  const jsUi = [
    {
      name: "react",
      logo: react,
      level: "expert",
    },
    {
      name: "Redux",
      logo: redux,
      level: "expert",
    },
    {
      name: "Vue",
      logo: vue,
      level: "comfortable",
    },
  ];
  const frameworks = [
    {
      name: "expressjs",
      logo: expressjs,
      level: "comfortable",
    },
    {
      name: "node js",
      logo: nodejs,
      level: "comfortable",
    },
  ];
  const cms = [
    {
      name: "wordpress",
      logo: wordpress,
      level: "comfortable",
    },
    {
      name: "Elementor",
      logo: elementor,
      level: "Expert",
    },
  ];

  const frontendFrameworks = [
    {
      name: "Bootstrap",
      logo: bootstrap,
      level: "Expert",
    },
    {
      name: "React Bootstrap",
      logo: reactBootstrap,
      level: "Expert",
    },
    // {
    //   name: "Ant Desgin",
    //   logo: antd,
    //   level: "comfortable",
    // },
    // {
    //   name: "Material Ui",
    //   logo: materialUi,
    //   level: "comfortable",
    // },
    {
      name: "tailwind css",
      logo: tailwindcss,
      level: "comfortable",
    },
  ];

  const databases = [
    {
      name: "MongoDB",
      logo: mongoDB,
      level: "comfortable",
    },
  ];

  const versionControl = [
    {
      name: "git",
      logo: git,
      level: "comfortable",
    },
  ];

  const webBrowser = [
    {
      name: "google chrome",
      logo: googleChrome,
      level: "expert",
    },
    {
      name: "firefox",
      logo: firefox,
      level: "expert",
    },
    // {
    //   name: "Microsoft edge",
    //   logo: edge,
    //   level: "expert",
    // },
  ];

  const tools = [
    {
      name: "vscode",
      logo: vscode,
      level: "expert",
    },
  ];
  const graphic = [
    {
      name: "photoshop",
      logo: photoshop,
      level: "expert",
    },
    {
      name: "figma",
      logo: figma,
      level: "expert",
    },
  ];
  return (
    <div id="techStack" className="tech-stack">
      <div className="section-heading">
        <h4>Tech Stack</h4>
      </div>
      <div className="stack-wrapper">
        <div className="stack-content">
          <div className="stack-heading">
            <h4>Front-End Frameworks</h4>
          </div>
          <div className="stack-item">
            <ul>
              {frontendFrameworks.map((item) => (
                <li key={uuid()}>
                  <img src={item.logo} alt={item.logo} />
                  <span className="item-name">{item.name}</span>
                  <span>{item.level}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="stack-content">
          <div className="stack-heading">
            <h4>languages</h4>
          </div>
          <div className="stack-item">
            <ul>
              {languages.map((item) => (
                <li key={uuid()}>
                  <img src={item.logo} alt={item.logo} />
                  <span className="item-name">{item.name}</span>
                  <span>{item.level}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="stack-content">
          <div className="stack-heading">
            <h4>Javascript UI</h4>
          </div>
          <div className="stack-item">
            <ul>
              {jsUi.map((item) => (
                <li key={uuid()}>
                  <img src={item.logo} alt={item.logo} />
                  <span className="item-name">{item.name}</span>
                  <span>{item.level}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="stack-content">
          <div className="stack-heading">
            <h4>Frameworks</h4>
          </div>
          <div className="stack-item">
            <ul>
              {frameworks.map((item) => (
                <li key={uuid()}>
                  <img src={item.logo} alt={item.logo} />
                  <span className="item-name">{item.name}</span>
                  <span>{item.level}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="stack-content">
          <div className="stack-heading">
            <h4>Databases</h4>
          </div>
          <div className="stack-item">
            <ul>
              {databases.map((item) => (
                <li key={uuid()}>
                  <img src={item.logo} alt={item.logo} />
                  <span className="item-name">{item.name}</span>
                  <span>{item.level}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="stack-content">
          <div className="stack-heading">
            <h4>CMS</h4>
          </div>
          <div className="stack-item">
            <ul>
              {cms.map((item) => (
                <li key={uuid()}>
                  <img src={item.logo} alt={item.logo} />
                  <span className="item-name">{item.name}</span>
                  <span>{item.level}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="stack-content">
          <div className="stack-heading">
            <h4>Web Browser</h4>
          </div>
          <div className="stack-item">
            <ul>
              {webBrowser.map((item) => (
                <li key={uuid()}>
                  <img src={item.logo} alt={item.logo} />
                  <span className="item-name">{item.name}</span>
                  <span>{item.level}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="stack-content">
          <div className="stack-heading">
            <h4>Tools</h4>
          </div>
          <div className="stack-item">
            <ul>
              {tools.map((item) => (
                <li key={uuid()}>
                  <img src={item.logo} alt={item.logo} />
                  <span className="item-name">{item.name}</span>
                  <span>{item.level}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="stack-content">
          <div className="stack-heading">
            <h4>Graphic Design</h4>
          </div>
          <div className="stack-item">
            <ul>
              {graphic.map((item) => (
                <li key={uuid()}>
                  <img src={item.logo} alt={item.logo} />
                  <span className="item-name">{item.name}</span>
                  <span>{item.level}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="stack-content">
          <div className="stack-heading">
            <h4>Version Control</h4>
          </div>
          <div className="stack-item">
            <ul>
              {versionControl.map((item) => (
                <li key={uuid()}>
                  <img src={item.logo} alt={item.logo} />
                  <span className="item-name">{item.name}</span>
                  <span>{item.level}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TechStack;
